const Tag = ({ text, fs, tagStyles }) => (
  <span
    className={`text-smalltag tag-padding appHeader fw-500 ${fs ? 'fs-14' : 'fs-12'} rounded ${
      tagStyles ? tagStyles : ''
    }`}>
    {text}
  </span>
);

export default Tag;
